import { AuthStatus } from '@/enums';
import { captureException } from '@/utils/sentry';
import { gql, useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';

export const LOGIN_MUTATION = gql`
  mutation Auth_UserLogin($supplierUUID: uuid) {
    restaurantEmployeeLogin(supplier_id: $supplierUUID) {
      employee_id
    }
  }
`;

export const useAuthQueries = (
  authStatus: AuthStatus | null,
  previousAuthStatus: AuthStatus | null,
  supplierUUID: string | null,
) => {
  const [tracked, setTracked] = useState(false);

  const [login] = useMutation(LOGIN_MUTATION);

  useEffect(() => {
    // Reset when status changes in case of multiple auth actions
    setTracked(false);
  }, [authStatus, previousAuthStatus]);

  useEffect(() => {
    if (tracked) {
      return;
    }

    (async () => {
      try {
        switch (authStatus) {
          case AuthStatus.Authenticated:
            if (previousAuthStatus === AuthStatus.NotAuthenticated) {
              await login({
                variables: {
                  supplierUUID: supplierUUID || undefined,
                },
              });
              setTracked(true);
            }

            break;
          // TODO - any other auth mutations
        }
      } catch (e) {
        captureException(e);
      }
    })();
  }, [authStatus, login, previousAuthStatus, tracked, supplierUUID]);
};
